import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Navbar';
import Dashboard from './Dashboard';
import Announcements from './Announcements'; // you will create this
import SymbolPage from './SymbolPage';
import UpcomingEvents from './UpcomingEvents';
import FundRaise from './FundRaise';
import Trades from './Trades';
import AboutUs from './AboutUs';
import Terms from './Terms';
import Contact from './Contact';
import Results from './Results';
import Resources from './Resources';
import Chat from './Chat'
import News from './News'
import Learning from './Learning';
import UserPage from './UserPage';
import Scanners from './Scanners';
import Footer from './Footer';
import Playground from './Playground';
import Interviews from './interviews'
import Search from './Search'
import MacroData from './MacroData';
import Reports from './Reports';


function App() {

// First value → top = 5px
// Second value → right and left = 5px
// Third value → bottom = 20px

  return (

    <Router>
      <Navbar/>
        <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/announcements" element={<Announcements />} />
            <Route path="/upcoming_events" element={<UpcomingEvents />} />
            <Route path="/fund_raise" element={<FundRaise />} />
            <Route path="/trades" element={<Trades />} />
            <Route path="symbol/:symbol" element={<SymbolPage />} />
            <Route path="/search" element={<Search />} />
            <Route path="/search/:type/:name" element={<Search />} />
            <Route path="user/:user" element={<UserPage />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/results" element={<Results />} />
            <Route path="/News" element={<News />} />
            <Route path="/Resources" element={<Resources />} />
            <Route path="/scanners" element={<Scanners />} />
            <Route path="/chat" element={<Chat />} />
            <Route path="/learning" element={<Learning />} />
            <Route path="/interviews" element={<Interviews />} />
            <Route path="/playground" element={<Playground />} />
            <Route path="/import-export" element={<MacroData />} />
            <Route path="/reports" element={<Reports />} />
        </Routes>
      {/* <Footer/> */}
    </Router>
  );
}

export default App;
